<template>
</template>

<script>
import auth from '@/f1/service/auth';

export default {
  created() { console.log('[vue] logout', 'created'); },
  destroyed() { console.log('[vue] logout', 'destroyed'); },
  mounted() {
    auth.logout(); this.$router.push('/login')
  }
}
</script>